import Devbsd1 from "./devbsd (1).webp";
import Devbsd2 from "./devbsd (2).webp";
import Devbsd3 from "./devbsd (3).webp";

const devbsd = [Devbsd1, Devbsd2, Devbsd3];

export default devbsd;
